<template>
  <div class="agent-list">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item label="发展专员">
          <el-input
            placeholder="请输入"
            clearable
            v-model="formInline.developerName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="handleCurrentChange(1)"
          >查询用户</el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column header-align="center" prop="name" label="用户名" />
        <el-table-column header-align="center" prop="mobilePhone" label="手机号" />
        <el-table-column header-align="center" prop="openId" label="openId" />
        <el-table-column header-align="center" prop="createTime" label="创建时间" />
        <el-table-column
          header-align="center"
          align="center"
          label="公众号状态"
        >
          <template slot-scope="scope">
            <span v-text="scope.row.isSubscribe?'已关注':'未关注'" :style="{color:scope.row.isSubscribe?'#67c23a':'#f56c6c'}"/>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="received" label="已领取总额(元)" />
        <el-table-column header-align="center" align="center" prop="unReceived" label="未领取余额(元)"/>
        <el-table-column header-align="center" align="center" prop="enterpriseName" label="企业名称"/>
        <el-table-column header-align="center" align="center" prop="developerName" label="发展专员"/>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click="lookAgent(scope.row)"
              size="mini"
              plain
            >
              查看下线
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      />
    </div>
  </div>
</template>

<script>
  import { getAgentPage as getList } from 'api/request'
  import { SetTableH } from '../../../utils/utils'
  export default {
    name: 'agentList',
    data() {
      return {
        loading: false,
        dataList: [],
        tableH: '250',
        pageObj: {
          total: 0,
          PageIndex: 1,
          PageSize: 10
        },
        formInline: {
          developerName: '',
        }
      }
    },
    methods: {
      async getList() {
        const params = {
          PageIndex: this.pageObj.PageIndex,
          PageSize: this.pageObj.PageSize,
          developerName: this.formInline.developerName
        }
        this.loading = true
        let data = await getList(params)
        if (data) {
          this.dataList = data.rows
          this.pageObj.total = data.total
          this.loading = false
        }
      },
      handleSizeChange(val) {
        this.pageObj.PageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageObj.PageIndex = val
        this.getList()
      },
      reset() {
        for (let key in this.formInline) {
          this.formInline[key] = ''
        }
        this.handleCurrentChange(1)
      },
      lookAgent(row) {
        this.$router.push({path: '/subordinate/list', query: { id: row.id, name: row.name }})
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
  }
</script>

<style scoped lang="scss">
  .agent-list{
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
